import { options, title } from 'Containers/steps/Consts'
import { t } from 'i18next'
import { ManageSubscriptionStep, ManageSubscriptionStepId } from 'types/manageSubscriptionTypes'

export function getCancelSubscriptionSuccessStep(): ManageSubscriptionStep {
  return {
    id: ManageSubscriptionStepId.CancelSubscriptionSuccess,
    type: 'custom',
    allowNext: true,
    wordings: {
      title: t(`${ManageSubscriptionStepId.CancelSubscriptionSuccess}.${title}`)
    }
  }
}
